"use client";

import type { ConversationHeaderResponse } from "~/conversations/types/conversation";

type CreateConversationPayload = {
  title: string;
  workspaceId: number;
};

type CreateConversationParams = {
  signal: AbortSignal;
};

async function createConversation(
  payload: CreateConversationPayload,
  { signal }: CreateConversationParams,
): Promise<ConversationHeaderResponse> {
  try {
    const response = await fetch("/api/conversations", {
      signal,
      method: "POST",
      body: JSON.stringify({
        title: payload.title,
        // API expectation
        // eslint-disable-next-line camelcase
        workspace_id: payload.workspaceId,
      }),
    });

    return response.json();
  } catch (error) {
    console.error("Error creating conversation:", error);
    throw new Error("INTERNAL_SERVER_ERROR");
  }
}

export type { CreateConversationPayload };
export { createConversation };
